if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  // Site SLIDERS
  $(".sym-slides").slick({
    accessibility: true,
  });

  // $(".weddings-slider").slick({
  //   accessibility: true,
  //   fade: true,
  //   dots: true,
  //   appendDots: ".appendDots",
  //   arrows: false,
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  // });

  $(".weddings-slider").slick();

  $(".intro-slider").slick({
    fade: true,
    autoplay: false,
    autoplaySpeed: 2000,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 3000,
  });
  $(".reviews").slick({
    fade: true,
    accessibility: true,
    dots: true,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  });
  //Columns Slider
  $(".columns-block-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
        },
      },
    ],
  });
  //   END Columns slider
  $(".gallery-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  });
  // Mobile galley slider
  if (document.querySelector(".gallery-slider-mobile")) {
    $(".gallery-slider-mobile").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerPadding: "0px",
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
    });
  }
  // End mobile gallery slider
  // END Site SLIDERS

  $(".js-slick-dots").each((i, dots) => {
    $("button", dots).click((e) => {
      let slideTo = $(e.currentTarget).data("goto");
      $(dots).closest(".slick-slider").slick("slickGoTo", slideTo);
    });
  });

  if (document.querySelector(".gallery-block")) {
    let images = document.querySelectorAll(".gallery-block .slick-slide");
    let arrows = document.querySelectorAll(".gallery-block .slick-arrow");
    arrows.forEach((arrow) => {
      arrow.addEventListener("click", () => {
        getImages(images);
      });
    });
  }
  function getImages(images) {
    let centerImage = "";
    let prev = "";
    let next = "";
    images.forEach((image) => {
      if (
        image.classList.contains("small") ||
        image.classList.contains("big")
      ) {
        image.classList.remove("small");
        image.classList.remove("big");
      }
      if (image.classList.contains("slick-center")) {
        centerImage = image;
        prev = centerImage.previousSibling;
        next = centerImage.nextElementSibling;
        prev.classList.add("small");
        next.classList.add("big");
        console.log(prev);
        console.log(centerImage);
        console.log(next);
      }
    });
  }

  // conditional to make all privacy-policy page titles lowercase
  if (document.querySelector("body.privacy-policy")) {
    let titles = document.querySelectorAll(".text-modules h3");
    let myTitles = [...titles];
    myTitles.forEach((title) => {
      title.innerHTML = title.innerHTML.toLowerCase();
    });
  }

  // // Burger menu tablet
  if (document.querySelector(".js-tb-burgerMenu")) {
    let burger = document.querySelector(".js-tb-burgerMenu");
    let navigate = document.querySelector(".navigations");
    burger.addEventListener("click", () => {
      navigate.classList.toggle("open");
      burger.classList.toggle("open");
    });
  }
})();
